<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="title">Gráficos</h4>
          </md-card-header>
          <md-card-content>
            <div class="md-layout mb-20">
              <div class="md-layout-item md-size-33 md-xsmall-size-100">
                <md-field>
                  <label>Tipo de Gráfico</label>
                  <md-select v-model="tipo_grafico">
                    <md-option value="unidades">Pontuação Unidades</md-option>
                    <md-option value="categorias" v-if="false">Categoria</md-option>
                    <md-option value="categorias_unidades">Categorias x Unidades por um período</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-33 md-xsmall-size-100">
                <md-field>
                  <label v-if="tipo_grafico != 'categorias_unidades'">Período Início</label>
                  <label v-if="tipo_grafico == 'categorias_unidades'">Período</label>

                  <md-input
                    name="periodo_inicio"
                    type="text"
                    placeholder="mês/Ano"
                    v-mask="'##/####'"
                    :masked="true"
                    v-model="periodo_inicio"
                  ></md-input>
                  <md-select v-model="mes_inicio" v-if="false">
                    <md-option
                      v-for="(item,index) in meses"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div
                class="md-layout-item md-size-33 md-small-size-33 md-xsmall-size-100"
                v-if="tipo_grafico != 'categorias_unidades'"
              >
                <md-field>
                  <label>Período Fim</label>

                  <md-input
                    name="periodo_fim"
                    type="text"
                    placeholder="mês/Ano"
                    :masked="true"
                    v-mask="'##/####'"
                    v-model="periodo_fim"
                  ></md-input>
                  <md-select v-model="mes_fim" v-if="false">
                    <md-option value="-1">-Mês Fim-</md-option>
                    <md-option
                      v-for="(item,index) in meses"
                      :key="index"
                      :value="item.value"
                    >{{item.label}}</md-option>
                  </md-select>
                </md-field>
              </div>

              <div
                class="md-layout-item md-size-20 md-small-size-45 md-xsmall-size-100"
                v-if="false"
              >
                <md-field>
                  <label>Ano</label>
                  <md-input name="ano" type="text" placeholder="Ano" v-mask="'####'" v-model="ano"></md-input>
                </md-field>
              </div>
            </div>

            <div class="md-layout mb-20">
              <div class="md-layout-item md-size-50 md-medium-size-100">
                <label>Cliente / Estabelecimento</label>
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select2"
                    :options="items_clientes"
                    v-model="id_cliente"
                    :searchable="true"
                    language="pt-BR"
                    v-on:change="loadUnidade"
                  ></vue_select>
                </md-field>
              </div>
            </div>

            <div class="md-layout mb-20" v-if="tipo_grafico =='categorias' && id_cliente != null">
              <div class="md-layout-item md-size-50 md-medium-size-100">
                <label>Unidade</label>
                <md-field>
                  <vue_select
                    class="vue-select2"
                    name="select2"
                    :options="items_unidade_select"
                    v-model="id_unidade"
                    :searchable="true"
                    language="pt-BR"
                  ></vue_select>
                </md-field>
              </div>
            </div>

            <div
              class="md-layout mb-20"
              v-if=" ( tipo_grafico =='unidades' || tipo_grafico =='categorias_unidades'   ) && id_cliente != null"
            >
              <div class="md-layout-item md-size-50 md-medium-size-100">
                <label>Unidades</label>
                <checkbox_list
                  v-if="show_checkboxlist"
                  v-bind:items="items_unidade"
                  v-model="ids_unidades"
                  show_marcatodos="1"
                  field_value="id"
                  field_text="nome"
                ></checkbox_list>
              </div>
            </div>

            <div class="md-layout mb-20">
              <div
                class="md-layout-item md-size-50 md-xsmall-size-100"
                v-if="items_modelo.length > 1"
              >
                <md-field>
                  <label>CheckList</label>
                  <md-select v-model="id_modelo" v-on:change="load_setores">
                    <md-option
                      v-for="(item, index) in items_modelo"
                      :value="item.id"
                      :key="index"
                    >{{item.nome}}</md-option>
                  </md-select>
                </md-field>
              </div>
              <div
                class="md-layout-item md-size-50 md-xsmall-size-100"
                v-if="items_categoria.length > 0 && tipo_grafico == 'unidades'"
              >
                <md-field>
                  <label>Setor</label>
                  <md-select v-model="id_setor">
                    <md-option value="-1">--NOTA GERAL--</md-option>
                    <md-option
                      v-for="(item, index) in items_categoria"
                      :value="item.id"
                      :key="index"
                    >{{item.nome}}</md-option>
                  </md-select>
                </md-field>
              </div>
            </div>

            <div class="md-layout mb-20">
              <div class="md-layout-item md-size-100 flex">
                <md-field>
                  <label>Ordenar por</label>
                  <md-select v-model="ordenar_grafico">
                    <md-option value="unidade_asc">Nome da Unidade - Crescente</md-option>
                    <md-option value="unidade_desc">Nome da Unidade - Decrescente</md-option>
                  </md-select>
                </md-field>
                <md-button
                  title="Adicionar"
                  class="md-round md-just-icon md-success ml-20"
                  v-on:click="load_data"
                  :disabled="disabled_button"
                  type="button"
                >
                  <md-icon>search</md-icon>
                </md-button>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>
    </div>

    <CardCadastro v-if="loaded_grafico">
      <div slot="header">
        <h4 class="title">Resultado</h4>
      </div>
      <div
        slot="header_button"
        style="width: 99%; float: right; text-align: right"
        v-if="show_print_button"
      >
        <md-button
          type="button"
          class="md-round md-just-icon md-primary"
          style="text-align: center"
          v-on:click="call_print"
        >
          <md-icon>print</md-icon>
        </md-button>

        <md-button
          title="Exportar Excel"
          class="md-round md-just-icon md-success"
          style="text-align: center"
          v-if="show_export_xls"
        >
          <download_excel
            :data="data_export_xls"
            :fields="fields_export_xls"
            :param="fields_export_xls"
            name="grafico.xls"
          >
            <md-icon>save_alt</md-icon>
          </download_excel>
        </md-button>
      </div>

      <div slot="body">
        <div v-if="loading" class="md-layout">
          <div class="md-layout-item md-size-100 box-carregando">
            <md-progress-spinner
              :md-diameter="40"
              :md-stroke="4"
              md-mode="indeterminate"
            >Carregando..</md-progress-spinner>
          </div>
        </div>
        <div v-if="grafico != null && grafico.data.length > 0 ">
          <div
            v-for="(item, index) in grafico.paginacao"
            :key="index"
            style="min-height: 600px; max-height: auto"
          >
            <bargroup
              :unidades="item.unidades"
              :data="grafico.data"
              :index="index"
              :defaultColor="false"
              :titulo="grafico.titulo"
              :onAppeared="setImagemJpeg"
            ></bargroup>
          </div>
          <div
            v-if="false && grafico != null && grafico.tabela != null && grafico.tabela.body.length > 0 "
            style="width: auto; overflow-x: scroll"
          >
            <h4>Tabela de Dados</h4>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th v-for="(item, index) in grafico.tabela.head" :key="index">{{item}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item_r, index_r) in grafico.tabela.body" :key="index_r">
                  <td v-for="(item, index) in item_r" :key="index">{{item}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </CardCadastro>
  </div>
</template>
<script>
import CardCadastro from "../../components/CardCadastro";
import Util from "../../library/Util";
import checkbox_list from "../components/checkbox_list";
import serviceUnidade from "../../services/EstabelecimentoService";
import serviceEstabelecimento from "../../services/EstabelecimentoService";
import serviceModelo from "../../services/ModeloChecklistService";
import Api from "../../library/Api";
import bargroup from "../components/graficos/bargroup";
import mixin_user from "../../library/mixin/user";

import serviceCliente from "../../services/ClienteService";
import serviceSerializator from "../../services/SerializatorService";
import vue_select from "../../components/Rend/vue-select/src/Select.vue";
import download_excel from "vue-json-to-excel";

import Swal from "sweetalert2";

export default {
  mixins: [mixin_user],
  components: {
    CardCadastro,
    checkbox_list,
    bargroup,
    vue_select,
    download_excel
  },
  watch: {
    id_cliente(val) {
      if (this.montado) {
        this.loadUnidade();
      }
    }
  },
  data() {
    return {
      meses: [],
      mes_inicio: 1,
      mes_fim: 1,
      ano: 2019,
      ids_unidades: "",
      id_unidade: null,

      id_cliente: null,

      items_unidade: [],
      items_modelo: [],
      items_unidade_select: [],
      items_categoria: [],
      disabled_button: true,
      grafico: null,
      show_checkboxlist: false,
      id_modelo: -1,
      id_setor: -1,
      loading: false,
      loaded_grafico: false,
      items_clientes: [],
      tipo_grafico: "unidades",
      montado: false,
      show_checkboxlist: false,
      data_export_xls: [],
      fields_export_xls: {},
      show_export_xls: false,

      images_jpeg: [],
      show_print_button: false,
      periodo_inicio: "",
      periodo_fim: "",

      ordenar_grafico: "unidade_asc"
    };
  },
  mounted() {
    this.meses = [
      { value: 1, label: "Janeiro" },
      { value: 2, label: "Fevereiro" },
      { value: 3, label: "Março" },
      { value: 4, label: "Abril" },
      { value: 5, label: "Maio" },
      { value: 6, label: "Junho" },
      { value: 7, label: "Julho" },
      { value: 8, label: "Agosto" },
      { value: 9, label: "Setembro" },
      { value: 10, label: "Outubro" },
      { value: 11, label: "Novembro" },
      { value: 12, label: "Dezembro" }
    ];

    this.ano = new Date().getFullYear();
    var self = this;

    this.periodo_inicio =
      new Date()
        .getMonth()
        .toString()
        .padStart(2, "0") +
      "/" +
      this.ano.toString();
    this.periodo_fim = this.periodo_inicio;

    /*
    serviceUnidade.getList("", "nome", "asc").then(function(response) {
      console.log("unidades?");
      console.log(response);
      self.items_unidade = response.data;
      self.disabled_button = false;
      self.show_checkboxlist = true;
    });

   
    */

    serviceCliente.getList("", "nome", "asc").then(function(response) {
      self.items_clientes = Util.getListToSelect(response.data, "id", "nome");
      self.montado = true;
    });
  },
  methods: {
    call_print() {
      console.log("call print?");

      if (this.tipo_grafico == "categorias_unidades") {
        this.periodo_fim = this.periodo_inicio;
      }
      var json = {
        images_jpeg: this.images_jpeg,
        tabela: this.grafico.tabela,
        id_cliente: this.id_cliente,
        id_setor: this.id_setor,
        ids_unidades: this.ids_unidades,
        ano: this.ano,
        mes_inicio: this.mes_inicio,
        mes_fim: this.mes_fim,
        periodo_inicio: this.periodo_inicio,
        periodo_fim: this.periodo_fim,
        tipo: this.tipo_grafico,
        tipo_grafico: this.tipo_grafico
      };

      var data = {
        data_value: JSON.stringify(json),
        variableName: "print",
        data_type: "grafico"
      };

      serviceSerializator.salvar(data).then(function(response) {
        console.log(response.data);
        if (response.data != null) {
          if (response.data.url != null) {
            window.open(response.data.url);
          }
        }
      });
    },
    setImagemJpeg(data, index) {
      let self = this;
      this.images_jpeg[index] = data;

      if (index == this.grafico.paginacao.length - 1) {
        setTimeout(function() {
          self.show_print_button = true;
        }, 1000);
      }
    },
    load_data() {
      var self = this;

      self.grafico = null;

      if (this.id_cliente == null || this.id_cliente == "") {
        Swal.fire({
          title: "Atenção!",
          html: "Selecione um cliente!",
          // showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          // cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        });
        return false;
      }

      if (
        (this.tipo_grafico == "unidades" ||
          this.tipo_grafico == "categorias_unidades") &&
        (this.ids_unidades == "" || this.ids_unidades == ",")
      ) {
        Swal.fire({
          title: "Atenção!",
          html: "Selecione pelo menos uma unidade!",
          // showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          // cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        });
        return false;
      }
      if (
        this.tipo_grafico == "categorias" &&
        (this.id_unidade == null || this.id_unidade == "")
      ) {
        Swal.fire({
          title: "Atenção!",
          html: "Selecione a unidade!",
          // showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          // cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        });
        return false;
      }

      if (this.periodo_inicio == "" || this.periodo_fim == "") {
        Swal.fire({
          title: "Atenção!",
          html: "Informe o período início e fim",
          // showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          // cancelButtonClass: "md-button md-danger",
          buttonsStyling: false
        });
        return false;
      }

      if (this.tipo_grafico == "categorias") {
        this.ids_unidades = this.id_unidade;
      }

      var data = {
        periodo_inicio: this.periodo_inicio, // this.mes_inicio + "/" + this.ano,
        periodo_final: this.periodo_fim, //this.mes_fim + "/" + this.ano,
        id_cliente: this.id_cliente,
        id_modelo: this.id_modelo,
        ids_unidades: this.ids_unidades,
        id_setor: this.id_setor,
        tipo_grafico: this.tipo_grafico,
        ordenar_grafico: this.ordenar_grafico
      };

      if (this.id_setor < 0) {
        data["id_setor"] = "";
      }

      self.loaded_grafico = true;
      self.loading = true;
      console.log(data);
      self.show_print_button = false;
      self.show_export_xls = false;

      Api.Call("graficos", "POST", data).then(function(response) {
        self.images_jpeg = [];

        self.grafico = response.data;
        self.loading = false;
        self.loaded_grafico = true;
        self.loadXlsDataExport();
        //console.log("Retorno?");
        //console.log(response);
        //console.log(self.loaded_grafico);

        if (self.grafico.data.length <= 0) {
          Swal.fire({
            title: "Atenção!",
            html: "Não há dados para o período pesquisado!",
            // showCancelButton: true,
            confirmButtonClass: "md-button md-success",
            // cancelButtonClass: "md-button md-danger",
            buttonsStyling: false
          });

          return false;
        }
      });
    },
    loadXlsDataExport() {
      var data_export_xls = [];
      // fields_export_xls: {},
      var fields_export_xls = {};

      for (var i = 0; i < this.grafico.tabela.head.length; i++) {
        var campo_nome = this.grafico.tabela.head[i];
        fields_export_xls[campo_nome] = "String";
      }
      for (var y = 0; y < this.grafico.tabela.body.length; y++) {
        var body = this.grafico.tabela.body[y];
        var registro = {};
        for (var i = 0; i < this.grafico.tabela.head.length; i++) {
          var campo_nome = this.grafico.tabela.head[i];
          registro[campo_nome] = body[i];
        }
        data_export_xls[data_export_xls.length] = registro;
      }

      this.fields_export_xls = fields_export_xls;
      this.data_export_xls = data_export_xls;
      this.show_export_xls = true;
    },
    loadUnidade() {
      let self = this;

      console.log("unidade?");
      self.show_checkboxlist = false;

      if (this.id_cliente == null) {
        self.items_unidade = [];
        return false;
      }

      /*serviceUnidade.getList("", "nome", "asc").then(function(response) {
      console.log("unidades?");
      console.log(response);
      self.items_unidade = response.data;
      self.disabled_button = false;
      self.show_checkboxlist = true;
    }); */

      serviceEstabelecimento
        .getListByParent("cliente", this.id_cliente)
        .then(function(response) {
          /* self.items_unidade = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          ); */

          console.log("Unidades obtidas? ");
          console.log(response.data);

          self.items_unidade = response.data;

          self.items_unidade_select = Util.getListToSelect(
            response.data,
            "id",
            "nome"
          );

          self.show_checkboxlist = true;
        });

      serviceModelo
        .getList({ id_cliente: this.id_cliente })
        .then(function(response) {
          self.items_modelo = response.data;

          if (self.items_modelo.length > 0) {
            self.id_modelo = self.items_modelo[0].id;
            self.load_setores();
          }
        });
    },
    load_setores() {
      var self = this;
      self.disabled_button = true;
      Api.Call("modelo_checklist_categorias/" + this.id_modelo).then(function(
        response
      ) {
        self.items_categoria = response.data;
        self.disabled_button = false;
      });
    }
  }
};
</script>